import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import * as React from 'react';
import { AvailableTimeslot } from "../../types";

export type TimeslotSelectionDialogLabels = {
    timeslotSelectionDialogTitle: string;
    closeTimeslotSelection: string;
};

type TimeslotSelectionDialogProps = {
    availableTimeslots: AvailableTimeslot[];
    isOpen: boolean;
    onChange: (timeslot: AvailableTimeslot) => void;
    onClose: () => void;
    labels: TimeslotSelectionDialogLabels;
};

export function TimeslotSelectionDialog({
    availableTimeslots,
    isOpen,
    labels,
    onChange,
    onClose
}: TimeslotSelectionDialogProps) {
    return (
        <Dialog onClose={onClose} open={isOpen} fullWidth={true}>
            <DialogTitle>{labels.timeslotSelectionDialogTitle}</DialogTitle>
            <Box
                component="hr"
                sx={{
                    color: 'text.secondary',
                    margin: 'unset'
                }}
            />
            <DialogContent
                sx={{
                    padding: '20px',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(250, 250, 250, 1)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px'
                }}
            >
                {availableTimeslots.map((timeslot, index) => (
                    <Paper
                        key={`${timeslot.time}-${index}`}
                        sx={{
                            display: 'flex',
                            gap: '8px',
                            padding: '8px',
                            cursor: 'pointer',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onClick={() => {
                            onChange(timeslot);
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '24px',
                                fontWeight: '700',
                                fontFamily: 'Gilroy',
                                color: 'text.primary'
                            }}
                        >
                            {timeslot.time}
                        </Typography>
                    </Paper>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{labels.closeTimeslotSelection}</Button>
            </DialogActions>
        </Dialog>
    );
}
